import { InternalStepOption } from '@booking-booster-client/models';
import { step1 } from './step-1';

export const settingsAdvertisersParameters: InternalStepOption[] = [step1];
